import { yup } from '@guiker/shared-framework'

export const createBatchChargePayloadSchema = yup.object({
  chargeDate: yup.string().required(),
})
